"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronsUpDown } from "lucide-react";
import { useSearchParams } from "next/navigation";
import { SidebarMenuButton, useSidebar } from "@/components/ui/sidebar";
import { useAppConfig } from "@/lib/config";
import { withOrgParam } from "@/lib/utils";
import { LoungeLogo } from "@llmgateway/shared/product-logos";
import { ProductIdentity, ProductSwitcher as SharedProductSwitcher } from "@llmgateway/shared/product-switcher";
export function ProductSwitcher() {
  const $ = _c(11);
  const config = useAppConfig();
  const searchParams = useSearchParams();
  const {
    isMobile,
    state
  } = useSidebar();
  const t0 = `${config.uiUrl}/dashboard`;
  const t1 = `${config.devpassUrl}/dashboard`;
  const t2 = `${config.airsideUrl}/dashboard`;
  let t3;
  if ($[0] !== searchParams) {
    t3 = withOrgParam("/", searchParams.get("orgId"));
    $[0] = searchParams;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t0 || $[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      gateway: t0,
      devpass: t1,
      airside: t2,
      lounge: t3
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = isMobile || state === "expanded" ? "bottom" : "right";
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SidebarMenuButton size="lg" tooltip="Switch product" className="data-[state=open]:bg-sidebar-accent"><span className="hidden size-8 shrink-0 items-center justify-center group-data-[collapsible=icon]:flex"><LoungeLogo className="size-6" /></span><ProductIdentity product="lounge" className="group-data-[collapsible=icon]:hidden" /><ChevronsUpDown className="ml-auto size-4 shrink-0 text-muted-foreground group-data-[collapsible=icon]:hidden" aria-hidden="true" /></SidebarMenuButton>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t5) {
    t7 = <SharedProductSwitcher current="lounge" urls={t4} side={t5}>{t6}</SharedProductSwitcher>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}